var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.788 6L.25 1.463A.857.857 0 0 1 1.463.251L6 4.788 10.537.25a.857.857 0 0 1 1.212 1.212L7.212 6l4.537 4.537a.857.857 0 0 1-1.212 1.212L6 7.212 1.463 11.75a.857.857 0 0 1-1.212-1.212L4.788 6z","fill":"#424242"}));
}

Close.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = Close;

Close.default = Close;
